import { ActionContext } from 'vuex';

import { ActionClass, ContextState } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class SetQueryAction implements ActionClass {

  public static execute({ state, commit }: ActionContext<ContextState, any>, query: string): void {
    commit(CONTEXT_CONSTS.mutations.setContext, {
      query: query
    });
  }

}
